// extracted by mini-css-extract-plugin
export default {"tooltip":"pn-z","sharingV2":"qn-z","sharingIconsV2":"rn-z","links":"sn-z","link":"tn-z","facebookV2":"un-z","twitterV2":"vn-z","pinterestV2":"wn-z"};